import { library } from "@fortawesome/fontawesome-svg-core";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faIgloo } from "@fortawesome/free-solid-svg-icons";
import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import auth from "../components/auth";
import BackDrop from "../components/Backdrop/Backdrop";
import Error from "../components/ErrorBoundary";
// import Input from '../../components/Manage/Input';
// import List from "../components/list/list";
import Search from "../components/Input";
import { url } from "../components/url";

library.add(faIgloo);

export default class View extends Component {
  state = {
    searchResult: [],
    isShowLoader: true
  };

  componentDidMount() {
    this.getTaxPayers();
  }

  logout = () => {
    auth.logout(() => {
      localStorage.removeItem("BRHMMobileToken");
    });
    this.props.history.push("/");
  };

  getTaxPayers = () => {
    this.setState({ isShowLoader: true });

    let formData = JSON.stringify({
      name: "viewBusinesses",
      param: {}
    });
    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.BRHMMobileToken
      },
      method: "post",
      body: formData
    })
      .then(response => response.json())
      .then(res => {
        // console.log(res);
        if (res.hasOwnProperty("error")) {
          alert(res.error.message);
          this.logout();
        } else {
          this.setState({
            searchResult: res.response.result,
            isShowLoader: false
          });
          // console.log(res);
        }
      })

      .catch(error => {
        this.setState({ isShowLoader: false });
        if (error + "" === "TypeError: Failed to fetch") {
          alert(
            "Please check if the device is connected to stable cellular data plan or WiFi."
          );
          // console.log(error);
        } else {
          // console.log(error);
        }
      });
  };

  checkContent = search_value => {
    if (search_value.length === 0) {
      alert("Type in a Company Name, Phone Number or BNTIN you want to find");
    } else {
      this.searchData(search_value);
    }
  };

  searchData = search_value => {
    this.setState({ isShowLoader: true });
    let formData = JSON.stringify({
      name: "searchBusiness",
      param: {
        search_value
      }
    });

    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.BRHMMobileToken
      },
      method: "POST",
      body: formData
    })
      .then(response => response.json())
      .then(res => {
        // console.log(res);
        if (res.hasOwnProperty("error")) {
          alert(res.error.message);
          this.logout();
        } else if (res === false) {
          let emptyResult = [
            {
              id: "null",
              coy_name: "null",
              regist_name: "null",
              BNTIN: "null",
              phone_no: "No Result Found",
              tax_office: "null"
            }
          ];
          this.setState({ searchResult: emptyResult, isShowLoader: false });
        } else {
          let data = [];
          res.forEach(element => {
            element.forEach(result => {
              // console.log(result);
              data.push(result);
            });
          });
          this.setState({ searchResult: data, isShowLoader: false });
        }
      })
      .catch(error => {
        this.setState({ isShowLoader: false });
        if (error === "TypeError: Network request failed") {
          alert(
            "Kindly check if the device is connected to stable cellular data plan or WiFi."
          );
        }
      });
  };

  render() {
    const data = this.state.searchResult;

    const columns = [
      {
        Header: "Company Name",
        accessor: "coy_name" // String-based value accessors!
      },
      {
        Header: "Registered Name",
        accessor: "regist_name" // String-based value accessors!
      },

      {
        Header: "BNTIN",
        accessor: "BNTIN"
      },
      {
        // id: 'number', // Required because our accessor is not a string
        Header: "Phone Number",
        accessor: "phone_no" // Custom value accessors!
      },
      {
        // id: 'number', // Required because our accessor is not a string
        Header: "Tax Office",
        accessor: "tax_office" // Custom value accessors!
      }
    ];
    let loading = (
      <BackDrop>
        <p>loading...</p>
      </BackDrop>
    );

    return (
      <div>
        {this.state.isShowLoader ? loading : null}
        <Search
          search={this.checkContent}
          placeholder={"comp name, reg name, station, tin or phone"}
        />
        <Error>
          <ReactTable
            data={data}
            columns={columns}
            defaultPageSize={15}
            resizable={true}
            filterable
            className="-striped -highlight"
            getTrProps={(state, rowInfo) => ({
              onClick: () => {
                // console.log(state)
                localStorage.setItem(
                  "MobileBusinessBntinId",
                  JSON.stringify(rowInfo.original)
                );
                this.props.history.push("/viewbustp");
              }
            })}
          />
        </Error>
      </div>
    );
  }
}
